module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "voucherView"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-sm table-bordered table-striped table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.ventries), function(ventry, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ventry.voucherNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ventry.date))]), _vm._v(" "), _c('td', _vm._l((ventry.dr_ledger), function(dr, id) {
      return _c('span', {
        key: id
      }, [_vm._v("\n                          " + _vm._s(dr.amt)), _c('br')])
    }), 0), _vm._v(" "), _c('td', _vm._l((ventry.cr_ledger), function(cr, id) {
      return _c('span', {
        key: id
      }, [_vm._v("\n                          " + _vm._s(cr.amt)), _c('br')])
    }), 0)])
  }), 0)])])])])])]), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Voucher Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Sr. No.")]), _vm._v(" "), _c('th', [_vm._v("Voucher No")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Dr")]), _vm._v(" "), _c('th', [_vm._v("Cr")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          CLOSE\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44612786!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/components/EmiVoucherEntry.vue
// module id = 862
// module chunks = 0